import { createSelector } from "reselect";
import { MAX_SENTENCES } from "../../lib/constants";
import { selectPurchasedLanguages } from "./languageSelectors";

// Selector to get the entire filters state
export const selectFilters = (state) => state.filters;

// Selector to get currentPage
export const selectCurrentPage = (state) => state.filters.currentPage;

// Selector to get searchQuery
export const selectSearchQuery = (state) => state.filters.searchQuery;
// Selector to get languageSearchQuery
export const selectLanguageSearchQuery = (state) =>
  state.filters.languageSearchQuery;
export const selectQuickFilter = (state) => state.filters.quickFilter;
export const selectRecentLanguages = (state) => state.filters.recentLanguages;

// Memoized selector to retrieve selected language IDs
// Filter languages based on selected names and map to their ids
export const selectLanguageIds = (state) => {
  const selectedLanguageSet = new Set(state.filters.selectedLanguages);

  return state.languages.languages
    .filter((item) => selectedLanguageSet.has(item.name)) // Use Set for efficient lookup
    .map((lang) => lang.id)
    .join(","); // Map to ids
};

// Selector to get itemsPerPage
export const selectItemsPerPage = (state) => state.filters.itemsPerPage;

// Selector to get africanOnly flag
export const selectAfricanOnly = (state) => state.filters.africanOnly;

// Selector to get syncChapters flag
export const selectSyncChapters = (state) => state.filters.syncChapters;

// Selector to get past searchQueries flag
export const selectSearchQueryHistory = (state) => state.filters.searchQueries;

// Selector to get selectedLanguages
export const selectSelectedLanguages = (state) =>
  state.filters.selectedLanguages;

// Selector to get chapters
export const selectChapters = (state) => state.filters.chapters;

// Selector to get totalPages
export const selectTotalPages = (state) => state.filters.totalPages;

// Selector to get volume
export const selectVolume = (state) => state.filters.volume;

// Selector to get shouldPayToViewMore
export const selectShouldPayToViewMore = (state) => {
  const selectedLanguagesCount = selectSelectedLanguages(state).length;
  const searchQuery = selectSearchQuery(state);
  const purchasedLanguageNames = new Set(
    selectPurchasedLanguages(state).map((lang) => lang.name)
  );
  const hasUnpurchasedSelected = selectSelectedLanguages(state).some(
    (language) => !purchasedLanguageNames.has(language)
  );

  return state.hasPaid.hasPaid
    ? searchQuery.length > 0 && hasUnpurchasedSelected
      ? state.filters.currentPage >= 10
      : true
    : searchQuery.length > 0
    ? state.filters.currentPage >= 10
    : state.sentences.sentences.length >=
        MAX_SENTENCES * selectedLanguagesCount &&
        state.filters.currentPage * state.filters.itemsPerPage >= MAX_SENTENCES;
};

// Selector to get maxItemsPerPage
export const selectMaxItemsPerPage = (state) => state.filters.maxItemsPerPage;

// Selector to get currentChapterId based on book_id
export const selectCurrentChapter = (bookId) =>
  createSelector(
    [selectChapters], // Assuming chapters are stored in sentences slice
    (chapters) => {
      return chapters.find((chap) => chap.book_id === bookId);
    }
  );
